export default "__VITE_ASSET__F8SF9luW__"